<template>
  <div>
    <RefrigeratorDesktop v-if="$vuetify.breakpoint.name !== 'xs'" />
    <RefrigeratorMobile v-else />
  </div>
</template>

<script>
import RefrigeratorDesktop from "@/components/Refrigerator/RefrigeratorDesktop";
import RefrigeratorMobile from "@/components/Refrigerator/RefrigeratorMobile";
export default {
  components: { RefrigeratorDesktop, RefrigeratorMobile },
  created() {
    document.title = this.$route.meta.title;
  },
};
</script>

<style>
@media (max-width: 470px) {
  .dekstop-only {
    display: none;
  }
  .mobile-only {
    display: block;
  }
}
@media (min-width: 470px) {
  .dekstop-only {
    display: block;
  }
  .mobile-only {
    display: none;
  }
}
</style>
